import xlsxExport from '../../shared/xlsxExport/xlsxExport';
import {
  periodColumnDefinition,
} from '../../shared/columnDefinitions';
import columnDefs from '../../shared/columnDefinitions/taxRates';
import { SheetExportTypes } from '@common/xlsxExport/xlsxExport.constants';

export default ({
  periodName,
  environmentSuffix,
  entities,
  shouldDisplayZero,
  hideDecimals,
  negativeMinus,
}) => {
  const taxRatesWithPeriods = entities.map(taxRate => ({
    periodName,
    ...taxRate,
  }));

  const sheetData = [
    {
      name: 'Tax Rates',
      type: SheetExportTypes.GRID,
      columnDefinitions: [
        periodColumnDefinition,
        ...columnDefs,
      ],
      data: taxRatesWithPeriods,
      options: {
        shouldDisplayZero,
        hideDecimals,
        negativeMinus,
      },
    },
    {
      name: 'Metadata',
      type: SheetExportTypes.CUSTOM,
      data: [],
      options: {
        addTimestamp: true,
      },
    },
  ];

  xlsxExport({
    sheetData,
    metadata: {
      fileName: `TLS_Tax_Rates_${periodName}${environmentSuffix}`,
      disableHeaderRendering: true,
    },
  });
};
